/* eslint-disable */
import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import React from "react";
import Col from "react-bootstrap/lib/Col";
import { connect, useDispatch } from "react-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import * as i18n from "util/i18n";
import * as Yup from "yup";

const SearchByFilter = (props) => {
    const dispatch = useDispatch();
    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            receipt: props.filtersGlobal.receipt || "",
            reference: "",
            detail: props.filtersGlobal.detail || "",
        },
        validationSchema: () =>
            Yup.object().shape({
                [props.filterName]: Yup.string().required(i18n.get("global.error.required")),
                reference: Yup.string().max(50, "Error en valor de detalle"),
            }),
        onSubmit: ({ ...filters }, formikBag) => {
            const { productId, filterName, setBalanceFalse, handleClickHideFilters = null } = props;
            if (handleClickHideFilters) {
                handleClickHideFilters();
            }
            setBalanceFalse();

            const parentSelectedFilter = "lastMonth";
            if (filterName === "detail") {
                dispatch(
                    accountsActions.details(
                        productId,
                        { parentFilter: parentSelectedFilter, detail: filters.detail },
                        formikBag,
                    ),
                );
                dispatch(
                    accountsActions.setFilterMovements({
                        selectedFilter: props.selectedFilter,
                        detail: filters.detail,
                    }),
                );
            } else if (filterName === "receipt") {
                dispatch(
                    accountsActions.details(
                        productId,
                        { parentFilter: parentSelectedFilter, operationNumber: filters.receipt },
                        formikBag,
                    ),
                );
                dispatch(
                    accountsActions.setFilterMovements({
                        selectedFilter: props.selectedFilter,
                        receipt: filters.receipt,
                    }),
                );
            }
        },
    };

    const handleReset = (allFormikProps) => {
        allFormikProps.setFieldValue(props.filterName, "");
    };

    return (
        <Formik {...formikProps}>
            {(allFormikProps) => (
                <Form>
                    <Container className="container--layout align-items-center" gridClassName="form-content">
                        {!!props.searchByField && (
                            <Col sm={12} md={6}>
                                {props.searchByField()}
                            </Col>
                        )}
                        <Col sm={12} md={!!props.searchByField ? 6 : null}>
                            <Field
                                component={props.FieldType}
                                hidePlaceholder
                                idForm={props.formID}
                                name={props.filterName}
                                type={props.filterType}
                            />
                        </Col>
                        {!!props.searchByField ? (
                            <>
                                <Col sm={12} md={6}>
                                    <Button
                                        className="btn-outline"
                                        label="echecks.clean.filters"
                                        onClick={() => handleReset(allFormikProps)}
                                    />
                                </Col>
                                <Col sm={12} md={6}>
                                    <Button bsStyle="primary" label="product.filters.filter" type="submit" />
                                </Col>
                            </>
                        ) : (
                            <Col sm={12} className="md:grid-cols-2">
                                <Button
                                    className="btn-outline"
                                    label="echecks.clean.filters"
                                    onClick={() => handleReset(allFormikProps)}
                                />
                                <Button bsStyle="primary" label="product.filters.filter" type="submit" />
                            </Col>
                        )}
                    </Container>
                </Form>
            )}
        </Formik>
    );
};

const mapStateToProps = (state) => ({
    filtersGlobal: accountsSelectors.getFilters(state),
});

export default connect(mapStateToProps)(SearchByFilter);
